export default __webpack_public_path__ + "static/videoIntro-480-22b4b1569af295ca1864ab4eb14ad4a7.mp4";